// extracted by mini-css-extract-plugin
export default {"root":"kOsRq6pYlKGIJPSF5jzj","content":"XTGqn13ef9Ybu13xs8a_"};